export default "__VITE_ASSET__CXzZNrxf__"